import { AppConfig } from "../services/app-config-service";

/**
 * Updates the favicon links in the document head based on the current app configuration
 */
export function updateFavicons() {
  const favicon = AppConfig.brandConfig.meta.favicon;

  // Update main favicon
  const iconLink = document.querySelector('link[rel="icon"][type="image/x-icon"]') as HTMLLinkElement;
  if (iconLink) {
    iconLink.href = favicon.ico;
  }

  // Update 32x32 favicon
  const icon32 = document.querySelector('link[rel="icon"][sizes="32x32"]') as HTMLLinkElement;
  if (icon32) {
    icon32.href = favicon.png32;
  }

  // Update 16x16 favicon
  const icon16 = document.querySelector('link[rel="icon"][sizes="16x16"]') as HTMLLinkElement;
  if (icon16) {
    icon16.href = favicon.png16;
  }

  // Update apple touch icon
  const appleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]') as HTMLLinkElement;
  if (appleTouchIcon) {
    appleTouchIcon.href = favicon.appleTouchIcon;
  }
}
